import * as React from "react";
import { useState, useEffect, useRef } from "react";
import { DataGrid } from "@mui/x-data-grid";
import Grid from "@mui/material/Grid2";
import Button from "@mui/material/Button";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import QueueOutlinedIcon from "@mui/icons-material/QueueOutlined";
import SyncIcon from "@mui/icons-material/Sync";
import { columns } from "../internals/data/gridData";

export default function CustomizedDataGrid() {
  const [rows, setRows] = useState([]);
  const newUpdatedRows = useRef([]);

  const saveDatabase = async () => {
    let records = [];
    if (newUpdatedRows.current.length <= 0) {
      return;
    }
    newUpdatedRows.current.forEach((element) => {
      if (records.length === 0) {
        records.push(element);
      } else {
        const itemExists = records.some((item) => item.id === element.id);
        if (itemExists) {
          records = records.map((item) =>
            item.id === element.id ? { ...item, ...element } : item
          );
        } else {
          records.push(element);
        }
      }
    });
    const tokenString = sessionStorage.getItem("token");
    const userToken = JSON.parse(tokenString);
    await fetch("https://stream.lpnserver.net/api/update-data", {
      method: "PUT",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: "Bearer " + userToken.accessToken.toString(),
      },
      body: JSON.stringify({ data: records }),
    }).then((response) => {
      if (response.status === 204) {
        alert("Save successfully!");
      } else {
        alert("Failed...");
      }
    });
  };

  const fetchData = async () => {
    newUpdatedRows.current = [];
    try {
      const tokenString = sessionStorage.getItem("token");
      const userToken = JSON.parse(tokenString);
      const response = await fetch(
        "https://stream.lpnserver.net/api/all-data",
        {
          method: "GET",
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
            Authorization: "Bearer " + userToken.accessToken.toString(),
          },
        }
      );
      const data = await response.json();
      setRows(data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const syncDataToServer = async () => {
    try {
      const tokenString = sessionStorage.getItem("token");
      const userToken = JSON.parse(tokenString);
      await fetch(
        "https://stream.lpnserver.net/api/sync-data",
        {
          method: "POST",
          headers: {
            "Access-Control-Allow-Origin": "*",
            Authorization: "Bearer " + userToken.accessToken.toString(),
          },
        }
      );
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    fetchData();
  }

  useEffect(() => {
    fetchData();
  }, []);

  const processRowUpdate = (newRow, oldRow) => {
    const updatedRows = rows.map((row) =>
      row.id === oldRow.id ? newRow : row
    );
    setRows(updatedRows);
    newUpdatedRows.current.push({
      id: newRow.id,
      name: newRow.name,
      index: newRow.index,
      url: newRow.url,
    });
    return newRow;
  };

  return (
    <div>
      <Grid container rowSpacing={2} spacing={1} columns={6}>
        <Grid size={{ md: 6, lg: 1 }}>
          <Button
            variant="outlined"
            size="small"
            endIcon={<SyncIcon />}
            fullWidth
            onClick={syncDataToServer}
          >
            SYNC
          </Button>
        </Grid>
        <Grid size={{ md: 6, lg: 3 }} />
        <Grid size={{ md: 6, lg: 1 }}>
          <Button
            variant="outlined"
            size="small"
            startIcon={<SaveOutlinedIcon />}
            fullWidth
            onClick={saveDatabase}
          >
            SAVE
          </Button>
        </Grid>
        <Grid size={{ md: 6, lg: 1 }}>
          <Button
            variant="outlined"
            size="small"
            startIcon={<QueueOutlinedIcon />}
            fullWidth
            disabled
          >
            NEW
          </Button>
        </Grid>
      </Grid>
      <br></br>
      <DataGrid
        autoHeight
        rows={rows}
        columns={columns}
        getRowClassName={(params) =>
          params.indexRelativeToCurrentPage % 2 === 0 ? "even" : "odd"
        }
        initialState={{
          pagination: { paginationModel: { pageSize: 20 } },
        }}
        pageSizeOptions={[20, 50, 100]}
        processRowUpdate={processRowUpdate}
        density="compact"
        slotProps={{
          filterPanel: {
            filterFormProps: {
              logicOperatorInputProps: {
                variant: "outlined",
                size: "small",
              },
              columnInputProps: {
                variant: "outlined",
                size: "small",
                sx: { mt: "auto" },
              },
              operatorInputProps: {
                variant: "outlined",
                size: "small",
                sx: { mt: "auto" },
              },
              valueInputProps: {
                InputComponentProps: {
                  variant: "outlined",
                  size: "small",
                },
              },
            },
          },
        }}
      />
    </div>
  );
}
